import type { FirebaseAuthTypes } from '@react-native-firebase/auth'
import type { User } from 'firebase/auth'

export type HeadlessFirebaseUser = User | FirebaseAuthTypes.User
